module.exports = __webpack_public_path__ + "img/zz18.f18f4ab4.png";